class TimelineFever extends React.Component {
  componentDidMount() {
    this.updateChart(this.props, this.state);
  }

  shouldComponentUpdate(nextProps, nextState) {
    this.updateChart(nextProps, nextState);

    return true;
  }

  updateChart(props, state) {
    let { scale, width, height, data, zoomed } = props;

    let extent = d3.extent(data.filter((d) => d.value > 0), (d) => d.value);
    let absMin = Math.floor(extent[0]);
    let absMax = Math.ceil(extent[1]);
    let pad = 0.025 * (absMax - absMin);

    let rootNode = d3.select(ReactDOM.findDOMNode(this));
    let textNodes = rootNode.selectAll("text");
    let lineNode = rootNode.select("path");

    textNodes
      .data([absMin, absMax])
      .text(function (d) {
        return isNaN(d) ? "..." : d;
      });

    let yScale = d3.scaleLinear()
      .domain([absMin - pad, absMax + pad])
      .range([height, 0]);

    let t0 = scale.invert(0);
    let t1 = scale.invert(width);

    let _data = data.filter(function (d) {
      return d.value > 0 && d.ts >= t0 && d.ts <= t1;
    });

    let dots = rootNode.select("g")
      .selectAll("circle")
      .data(_data);

    if (zoomed) {
      let h = (t1 - t0) / mc.math.MILLIS_PER_HOUR;
      let r = zoomed ? Math.min(3.5, 5.5 / h) : 0;

      dots
        .exit()
        .remove();

      dots = dots
        .enter()
        .append("circle")
        .merge(dots);

      dots
        .attr("cx", function (d, i) {
          return scale(d.ts);
        })
        .attr("cy", function (d, i) {
          return yScale(d.value);
        })
        .attr("r", r)
        .attr("data-tooltip", function (d, i) {
          return zoomed ? mc.format.number(d.value, props.precision) : null;
        });
    }
    else {
      dots.remove();
    }

    let line = d3.line()
      .defined(function (d, i) {
        if (!d.value) {
          return false;
        }

        if (i > 0 && (d.ts - data[i - 1].ts > (mc.math.MILLIS_PER_MINUTE * 5))) {
          return false;
        }

        return true;
      })
      .x(function(d, i) {
        return scale(d.ts);
      })
      .y(function(d, i) {
        return yScale(d.value);
      });

    lineNode
      .datum(data)
      .attr("d", line);
  }

  render() {
    let { width, height, ticks } = this.props;
    let rules = [];

    for (let i = 0; i < (ticks || 0); i++) {
      let y = ((i + 1) / (ticks + 1)) * height;

      rules.push(<line key={i} x1="0" y1={y} x2={width} y2={y}/>);
    }

    return (
      <g className="rc-timeline-fever">
        <rect x="0" y="0" width={width} height={height}/>
        <g>
          {rules}
        </g>
        <path/>
        <text x="4" y={height - 5}/>
        <text x="4" y="13"/>
      </g>
    );
  }
}

TimelineFever.defaultProps = {
  height: 90,
  ticks: 4
};

module.exports = TimelineFever;